/**
 * @generated SignedSource<<3cb0ddf51691994cf53f8e5e47c8bd7f>>
 * @relayHash 8548dc30e78f5c9db1613b302be67ab5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8548dc30e78f5c9db1613b302be67ab5

import { ConcreteRequest } from 'relay-runtime';
export type cskQueryZephrDataContainerQuery$variables = {
  articleId: string;
};
export type cskQueryZephrDataContainerQuery$data = {
  readonly node: {
    readonly categories?: ReadonlyArray<{
      readonly slug: string;
    }>;
    readonly internalCategories?: ReadonlyArray<{
      readonly slug: string;
    }>;
  } | null;
};
export type cskQueryZephrDataContainerQuery = {
  response: cskQueryZephrDataContainerQuery$data;
  variables: cskQueryZephrDataContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "articleId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "articleId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v2/*:: as any*/),
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cskQueryZephrDataContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryResourceType",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternalCategoryResourceType",
                "kind": "LinkedField",
                "name": "internalCategories",
                "plural": true,
                "selections": (v3/*:: as any*/),
                "storageKey": null
              }
            ],
            "type": "CustomStoryResourceType",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "cskQueryZephrDataContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryResourceType",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": (v5/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternalCategoryResourceType",
                "kind": "LinkedField",
                "name": "internalCategories",
                "plural": true,
                "selections": (v5/*:: as any*/),
                "storageKey": null
              }
            ],
            "type": "CustomStoryResourceType",
            "abstractKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8548dc30e78f5c9db1613b302be67ab5",
    "metadata": {},
    "name": "cskQueryZephrDataContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5ece6dff601ea035cf6794063683ca8a";

export default node;
